import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { HeaderProfileComponent } from './header-profile.component';
import { LayoutModule } from '../../../../layouts/layout.module';
import { DefaultComponent } from '../../default.component';
import { FormsModule } from '../../../../../../../node_modules/@angular/forms';
import {  PopoverModule } from 'ngx-bootstrap/popover';
import { NgxMaskModule } from 'ngx-mask';
import { MessageModule } from '@global-message/Message.module';
import { HistoryService } from 'app/vbt-ticari/common/_services/History.service';
import { UserService } from 'app/vbt-back-office/Role/Services/User.service';
import { HttpClientModule } from '@angular/common/http';
import { AgGridModule } from 'ag-grid-angular';

const routes: Routes = [
  {
    'path': '',
    'component': DefaultComponent,
    'children': [
      { 'path': '','component': HeaderProfileComponent }
    ]
  }
];
@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    LayoutModule,
    MessageModule,
    PopoverModule,
    NgxMaskModule.forRoot(),
    HttpClientModule,
    AgGridModule.withComponents()
  ],
 
  declarations: [
    HeaderProfileComponent
  ],

  providers: [
    HistoryService,
    UserService
  ],
  exports: [
    RouterModule,
    HeaderProfileComponent
  ],
})
export class HeaderProfileModule {



}
